import {
  BlogPostSection,
  IContentfulBlogPost,
  IContentfulLeadForm,
  IContentfulTable,
} from './shared-types'

export const newestPostFirst = (blogPosts: IContentfulBlogPost[]) =>
  blogPosts.sort((a, b) => {
    const dateA = new Date(a.createdAt)
    const dateB = new Date(b.createdAt)
    return dateA < dateB ? 1 : dateA > dateB ? -1 : 0
  })

export const isTableEntry = (
  section: BlogPostSection,
): section is IContentfulTable => section.internal.type === 'ContentfulTable'

export const isLeadForm = (
  section: BlogPostSection,
): section is IContentfulLeadForm =>
  section.internal.type === 'ContentfulLeadForm'
